import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Container, Row, Col, Button, Card, CardBody } from 'reactstrap'
import { Breadcrumbs } from '../../AbstractElements'
import { getIdData } from '../../lib/studentinfo'
import { StudentInfoCard } from './StudentInfoCard'
import { useReactToPrint } from 'react-to-print'

const ApplicationProfile = () => {
	const componentRef = useRef()
	const { id } = useParams()
	const navigate = useNavigate()
	const [studentInfo, setStudentInfo] = useState(null)
	const [loading, setLoading] = useState(true)

	const fetchStudentData = async () => {
		if (!id) return

		try {
			setLoading(true)
			const studentData = await getIdData(id)
			if (studentData && studentData.length > 0) {
				setStudentInfo(studentData[0])
			}
		} catch (error) {
			console.error('Error fetching student data:', error)
		} finally {
			setLoading(false)
		}
	}

	const handleBack = () => {
		navigate(-1)
	}

	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
		onBeforePrint: () => {
			removeBorderClasses()
		},
		onAfterPrint: () => {
			restoreBorderClasses()
		}
	})

	const removeBorderClasses = () => {
		const studentInfoCard = document.getElementById('student-info-card')
		studentInfoCard.style.display = 'none'
	}

	const restoreBorderClasses = () => {
		const studentInfoCard = document.getElementById('student-info-card')
		studentInfoCard.style.display = 'block'
	}

	useEffect(() => {
		fetchStudentData()
	}, [id])

	if (loading) {
		return (
			<Container fluid={true}>
				<div className="text-center py-5">
					<div className="spinner-border text-primary" role="status">
						<span className="visually-hidden">Loading...</span>
					</div>
					<p className="mt-2">Loading student profile...</p>
				</div>
			</Container>
		)
	}

	if (!studentInfo) {
		return (
			<Container fluid={true}>
				<Breadcrumbs parent="Student Management" title="Student Profile" mainTitle="Student Profile" />
				<Row>
					<Col sm="12">
						<Card>
							<CardBody>
								<div className="text-center py-5">
									<h5>Student not found</h5>
									<Button color="primary" onClick={handleBack} className="mt-3">
										<i className="fa fa-arrow-left me-2"></i>
										Go Back
									</Button>
								</div>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		)
	}

	return (
		<>
			<Breadcrumbs parent="Student Management" title="App Profile" mainTitle="App Profile" />
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<div className="d-flex justify-content-between align-items-center mb-3">
							<Button color="outline-secondary" onClick={handleBack} className="btn-sm">
								<i className="fa fa-arrow-left me-2"></i>
								Back
							</Button>
							<Button color="info" onClick={handlePrint} className="btn-sm">
								<i className="fa fa-print me-2"></i>
								Print Page
							</Button>
						</div>

						{/* Student Info Card */}
						<div id="student-info-card">
							<StudentInfoCard ref={componentRef} studentId={id} />
						</div>
					</Col>
				</Row>
			</Container>
		</>
	)
}

export { ApplicationProfile }
